import {pdf, Document, Page, View, Text, StyleSheet} from '@react-pdf/renderer';

export const generatePdfDocument = async (data: string[][], title?: string): Promise<Blob> => {
    const styles = StyleSheet.create({
        page: {
            flexDirection: 'column',
            display: 'flex',
            fontSize: 5,
            padding: 15
        },
        title: {
            textAlign: 'center',
            fontSize: 10,
            fontWeight: 'bold',
            marginBottom: 10
        },
        table: {
            display: 'flex',
            flexDirection: 'column',
            borderCollapse: 'collapse',
            width: '100%',
            border: '1px solid #ccc',
        },
        row: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'stretch',
            backgroundColor: '#f2f2f2',
            borderBottom: '1px solid #ccc',
        },
        lastRow: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'stretch',
            backgroundColor: '#f2f2f2',
        },
        cell: {
            flex: 1,
            textAlign: 'center',
            padding: '5px',
            borderRight: '1px solid #ccc',
        },
        lastCell: {
            flex: 1,
            textAlign: 'center',
            padding: '5px',
        },
    });

    return await pdf((
        <Document>
            <Page size="A4" orientation={"landscape"} style={styles.page}>
                <Text style={styles.title}>{title}</Text>
                <View style={styles.table}>
                {data.map((row, index) => {
                    const isLast = data.length - 1 === index;

                   return <View style={isLast ? styles.lastRow : styles.row} key={`tr-${index}`}>
                       {row.map((cell, index) => {
                           const isLast = row.length - 1 === index;

                           return <View style={isLast ? styles.lastCell : styles.cell} key={`tc-${index}`}>
                               <Text>{cell}</Text>
                           </View>
                       })}
                    </View>;
                })}
                </View>
            </Page>
        </Document>
    )).toBlob();
};
